function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -27.707)"
}, React.createElement("path", {
  className: "a",
  d: "M21.429,30.564H11.01L8.362,27.916a.714.714,0,0,0-.5-.209H1.429A1.43,1.43,0,0,0,0,29.136V46.278a1.43,1.43,0,0,0,1.429,1.429h20a1.43,1.43,0,0,0,1.429-1.429V31.993A1.43,1.43,0,0,0,21.429,30.564Zm0,15.714h-20V29.136H7.561l2.648,2.648a.714.714,0,0,0,.5.209H21.429Z"
}));

var SvgAddFolder = function SvgAddFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.857,
    height: 20,
    viewBox: "0 0 22.857 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-folder.53769b8d.svg";
export { ForwardRef as ReactComponent };